import {
  Emoji,
  EmojiSuggestionPluginKey,
  gitHubEmojis,
} from '@tiptap/extension-emoji';

/**
 * The built-in `Emoji` extension always registers a Suggestion plugin on `:`,
 * which conflicts with our `SuggestionMenu`-based picker. We strip that plugin
 * here so we keep:
 *   - shortcode replacement (`:smile:` → 😄) via input rule
 *   - emoticon replacement (`:-)` → 🙂) via input rule
 *   - paste rule
 *   - emoji-detection appendTransaction
 * but drop the `:`-trigger suggestion plugin so our `EmojiSuggestionMenu` owns
 * the picker UI.
 */
export const CoteraEmoji = Emoji.extend({
  addProseMirrorPlugins() {
    const plugins = this.parent?.() ?? [];
    return plugins.filter(
      (plugin) => plugin.spec.key !== EmojiSuggestionPluginKey
    );
  },
}).configure({
  emojis: gitHubEmojis,
  enableEmoticons: true,
});
